import React, { useState, useEffect } from 'react';
import { Typography, makeStyles, Box } from '@material-ui/core';
import { LabelButton } from 'common/components/Buttons/LabelButton';
import { NewModal } from 'common/components';
import GiftCardIcon from './GiftCardIcon';
import { useContent } from '../../../content/content-provider';
import GiftCardCheckBalance from './GiftCardCheckBalance';
import GiftCardBalance from './GiftCardBalance';

const styles = makeStyles(({ spacing }) => ({
  giftCardContainer: {
    padding: `${spacing(11)}px ${spacing(5)}px ${spacing(5)}px`,
    '& > .MuiTextField-root': {
      marginTop: spacing(5.5),
    },
  },
  useButton: {
    marginTop: spacing(11),
    marginBottom: '10px',
  },
}));

interface GiftCardQueryProps {
  redemptionAmount?: number;
  totalBalance?: number;
  remainingBalance?: number;
  cardNumber?: string;
}
interface GiftCardWrapperProps {
  getGiftCardBalance: (string: any) => void;
  useGiftCard: (string: any) => void;
  closeGiftCardModal: () => void;
  giftCardModal?: boolean;
  giftCardQuery?: GiftCardQueryProps;
  giftCardError?: string | null;
  giftCardErrorTime?: string | null;
}

const GiftCardWrapper = ({
  getGiftCardBalance,
  useGiftCard,
  closeGiftCardModal,
  giftCardModal = false,
  giftCardQuery = {},
  giftCardError = null,
  giftCardErrorTime = null,
}: GiftCardWrapperProps) => {
  const [content] = useContent();

  const classes = styles();

  const [open, setOpen] = useState(giftCardModal);

  useEffect(() => {
    if (!giftCardModal && open) {
      setOpen(false);
    }
    // eslint-disable-next-line no-autofix/react-hooks/exhaustive-deps
  }, [giftCardModal]);

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
    closeGiftCardModal();
  };

  return (
    <>
      <Box mt={6} textAlign="center">
        <LabelButton
          onClick={openDialog}
          icon={<GiftCardIcon />}
          label={content.giftCard.openModalButton}
        />
      </Box>
      <NewModal
        fullScreen
        open={open}
        handleClose={closeDialog}
        data-testid="gift-card-dialog"
        displayCaloriesBanner={false}
      >
        <Box className={classes.giftCardContainer}>
          <Typography variant="h1">{content.giftCard.title}</Typography>
          {giftCardQuery && giftCardQuery.totalBalance ? (
            <GiftCardBalance giftCardQuery={giftCardQuery} useGiftCard={useGiftCard} />
          ) : (
            <GiftCardCheckBalance
              getGiftCardBalance={getGiftCardBalance}
              giftCardError={giftCardError}
              giftCardErrorTime={giftCardErrorTime}
            />
          )}
        </Box>
      </NewModal>
    </>
  );
};

export default GiftCardWrapper;
